module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    class: {
      'isIndex': _vm.$route.path == '/', 'isJapanese': _vm.$i18n.locale == 'jp'
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "header-nav"
  }, [_c('div', {
    staticClass: "header-nav-left"
  }, [(_vm.$route.path == '/') ? _c('img', {
    attrs: {
      "src": _vm.getImgs('logo2.png')
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.getImgs('logo.png')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "header-nav-center"
  }, [_c('div', {
    staticClass: "nav-menu"
  }, _vm._l((_vm.menus), function(menu) {
    return _c('router-link', {
      key: menu.path,
      staticClass: "menu-item menu-li",
      attrs: {
        "to": menu.title == 'mall.home' || menu.title == 'mall.bookingcenter' || menu.title == 'mall.btripplateform' || menu.title == 'mall.tourism' || menu.title == 'mall.contactUs' ? menu.path : ''
      }
    }, [_vm._v(_vm._s(_vm.$t(menu.title)))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "header-nav-right"
  }, [_c('el-dropdown', {
    style: ({
      'color': _vm.$route.path != '/' ? '#fff' : '#323232'
    }),
    on: {
      "command": _vm.changelang
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v(_vm._s(_vm.$t('system.langsetting')))]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "cn"
    }
  }, [_vm._v(_vm._s(_vm.$t('system.china')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "en"
    }
  }, [_vm._v(_vm._s(_vm.$t('system.english')))]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "jp"
    }
  }, [_vm._v(_vm._s(_vm.$t('system.japan')))])], 1)], 1), _vm._v(" "), (_vm.ticketInfo.UserName) ? _c('div', {
    staticClass: "ticketInfo"
  }, [_c('router-link', {
    staticClass: "menu-item menu-li",
    attrs: {
      "to": {
        name: 'UserMain'
      }
    }
  }, [_c('span', {
    staticClass: "index_exit"
  }, [_vm._v(_vm._s(_vm.ticketInfo.UserName))])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "menu-item index_exit",
    on: {
      "click": _vm.exit
    }
  }, [_vm._v(_vm._s(_vm.$t('system.loginout')))])], 1) : _c('div', {
    staticClass: "ticketInfo"
  }, [_c('div', {
    staticClass: "index_login",
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm.$t('system.login')))]), _vm._v(" "), _c('div'), _vm._v(" "), _c('router-link', {
    staticClass: "index_exit",
    attrs: {
      "to": "/Company/Register",
      "tag": "div"
    }
  }, [_vm._v(_vm._s(_vm.$t('system.registernow')))])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb32541a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modules/header.vue
// module id = 569
// module chunks = 221